import { useContext } from "react"
import VisibilityContext from "src/provider/state-manager/visibilityProvider"
import access from 'src/utils/localAccess'
import { AppLabel, AppText, Button, CustomContainer, GridContainer } from "src/style"
import { DisplayBox } from "src/popup"


export const Responder: React.FC<any> = () => {
    const { visibility: {response}, responder } = useContext(VisibilityContext)

    function handleNav (method: any) {
        responder.hide()
        if (method) method()
    }

    return (
        <>
            { response.status &&
                <DisplayBox close={() => responder.hide()}>
                    <GridContainer>
                        {response.icon}
                        <CustomContainer topMargin='5'>
                            <AppLabel 
                                textSize='2' fontWeight='600' color='#27272E' align='center'
                                style={{display: 'block'}}>
                                {response.title}
                            </AppLabel>
                            <AppText topMargin='1' align='center'>{response.text}</AppText>
                        </CustomContainer>
                        <Button
                            width='11' borderColor='#4C6FFF' height='4.6'
                            hoverBgColor='#ffffff' hoverColor='#4C6FFF'
                            radius="0.8" topMargin='4'
                            onClick={() => handleNav(response?.btnMethod)}
                        >
                            {response.btnText}
                        </Button>
                    </GridContainer>
                </DisplayBox>
            }
        </>
    )
}